<button id="{{widgetContent?.id}}" (click)="onClick()"
        class="widget-tile">
    <div class="widget-icon-box">
        <img src={{widgetContent.icon}} alt="{{ widgetContent.label }} icon"/>
    </div>
    <div class="widget-label">{{ widgetContent.label | translate }}</div>
</button>
